import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { DeleteIcon } from "themes/Icon";
import ButtonComp from "../Button";
import "./tab_comp.scss";

function TabComp({
  onChange,
  data,
  exportData,
  handleTabChange,
  count,
  isLoading,
  setDlt,
  tabActive,
}) {
  const [delayedLoading, setDelayedLoading] = useState(isLoading);

  useEffect(() => {
    let timer;

    if (!isLoading) {
      timer = setTimeout(() => {
        setDelayedLoading(false);
      }, 1000);
    } else {
      setDelayedLoading(true);
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  const handleTabClick = (key) => {
    if (!delayedLoading) {
      handleTabChange(key);
    }
  };

  const SuffixAction = (
    <div className="flex align-center gap-2">
      <h5 className="selected-text">{count} Selected:</h5>
      {/* Uncomment and adjust this button if you want to reintroduce Export functionality
      <ButtonComp
        onClick={() => exportToCSV(exportData)}
        prefix={<UploadIcon />}
        height={26}
        variant="secondary"
      >
        Export
      </ButtonComp>
      */}
      <ButtonComp
        onClick={() => setDlt(true)}
        prefix={<DeleteIcon />}
        height={26}
        variant="secondary"
      >
        Delete
      </ButtonComp>
    </div>
  );

  return (
    <Tabs
      tabBarExtraContent={count > 0 ? SuffixAction : null}
      className="tab-comp"
      defaultActiveKey="1"
      activeKey={tabActive}
      items={data.map((tab) => ({
        ...tab,
        label: (
          <div style={{ pointerEvents: delayedLoading ? "none" : "auto" }}>
            {tab.label}
          </div>
        ),
        onItemHover: delayedLoading ? () => {} : undefined,
        disabled: delayedLoading,
      }))}
      onChange={handleTabClick}
    />
  );
}

export default TabComp;
